import Call from '../Call.v2';
import {objToQs} from '../Utils';

const BidderFillRate = {
    get(type, filters) {
        return Call(`bidder/fillRate/${type}?${objToQs(filters)}`);
    },

    getGraph(type, filters) {
        return Call(`bidder/fillRate/${type}/graph?${objToQs(filters)}`);
    },

    getAffids() {
        return Call(`bidder/fillRate/affids`);
    }
};

export default BidderFillRate;



// WEBPACK FOOTER //
// ./src/services/API/components/BidderFillRate.js